import React, { useEffect } from 'react'
import { NavLink, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { ApplicationState } from 'AppReducer'
import { formatDateTime } from 'util/masks'

import { getCategoryList, deleteCategory } from '../redux/actions'

import Pagination from 'util/modules/Pagination'

const CategoryList: React.FC = () => {
  const dispatch = useDispatch()
  const { categoryList: { items, pagination } } = useSelector((state: ApplicationState) => state.categoryReducer)

  const history = useHistory()
  const { location: { search } } = history

  function handleFetch (): void {
    const query = new URLSearchParams(search)

    getCategoryList({
      page: query.get('page') || 1,
      limit: 10,
      fields: 'id,pictureSmall,pictureMedium,name,description,createdAt,updatedAt'
    })(dispatch)
  }

  function handleRemove (id: number): void {
    if (window.confirm('Tem certeza que deseja remover esta categoria?')) {
      deleteCategory(id)(dispatch).then(res => {
        if (res?.status === 'success') {
          history.push('/panel/category')
        }
      })
    }
  }

  useEffect(() => {
    handleFetch()
    // eslint-disable-next-line
  }, [search])

  const gridTemplateColumns = '50px 300px 1fr 200px 200px 160px'
  const defaulPicture = `${process.env.PUBLIC_URL}/img/default-img.png`

  return (
    <div className="row justify-start margin-top-32">
      <h2><i className="fa fa-history"/> Categorias Cadastrada</h2>
      <div className="list">
        <div className="list-header" style={{ display: 'grid', gridTemplateColumns }}>
          <div />
          <div className="padding-left-8">Nome</div>
          <div>Descrição</div>
          <div>Criado em</div>
          <div>Atualizado Em</div>
          <div />
        </div>

        {
          items.length === 0 &&
          <div className="list-row">
            <div className="grid-span">
              Nenhuma categoria cadastrada
            </div>
          </div>
        }
        {
          items.map(item => (
            <div className="list-row" key={item.id} style={{ display: 'grid', gridTemplateColumns }}>
              <img
                className="col-12 border-radius"
                style={{ height: 48, width: 48 }}
                src={item.pictureSmall || defaulPicture}
              />

              <div className="padding-left-8">{ item.name }</div>
              <div>{ item.description }</div>
              <div>{ formatDateTime(item.createdAt) }</div>
              <div>{ formatDateTime(item.updatedAt, '...') }</div>

              <div className="row">
                <span
                  onClick={(): void => handleRemove(item.id)}
                  className="button remove margin-right-8"
                  style={{ width: 48 }}
                >
                  <i className="fa fa-trash"/>
                </span>
                <NavLink className="button primary" style={{ width: 100 }} to={`/panel/category/${item.id}`}>
                  Editar
                </NavLink>
              </div>
            </div>
          ))
        }
      </div>

      <Pagination pagination={pagination} />
    </div>
  )
}

export default CategoryList
